import { useLocalizedNavigate } from '../../../hooks/useLocalizedNavigate';
import React, { useState, useRef, useEffect } from 'react';
import { logout } from '../../../store/auth/authSlice';
import { useAppDispatch } from '../../../store/hooks';
import { useAuth } from '../../../hooks/auth/useAuth';
import { Auth } from '../../../utils/types';
import { Title, TextField } from '../../common';

import './userMenu.css';
import { useTranslation } from '../../../hooks/translations/TranslationProvider';
import { DEFAULT_AVATAR_URL } from '../../../utils/consts';

interface UserMenuProps {
    authData: Auth | null;
}

const UserMenu = ({ authData }: UserMenuProps) => {
    const dispatch = useAppDispatch();
    const navigate = useLocalizedNavigate();
    const auth = useAuth();
    const { t } = useTranslation();

    const [showMenu, setShowMenu] = useState(false);
    const ref = useRef<HTMLImageElement | null>(null);

    useEffect(() => {
        document.addEventListener('mousedown', closeUserMenu);
        return () => {
            document.removeEventListener('mousedown', closeUserMenu);
        };
    });

    const closeUserMenu = (event: MouseEvent) => {
        event.stopPropagation();

        if (
            ref.current !== event.target && //@ts-ignore
            event.target?.className !== 'menu-element' &&
            //@ts-ignore
            event.target?.nodeName !== 'P'
        ) {
            setShowMenu(false);
        }
    };

    const showMenuHandler = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        event.stopPropagation();

        setShowMenu(true);
    };

    const logoutHandler = async (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setShowMenu(false);
        await dispatch(logout());
        navigate('/');
    };

    const navigateToMyProfile = () => {
        setShowMenu(false);
        navigate(`/users/${auth.authData?.id}`);
    };

    const navigateToSettings = () => {
        setShowMenu(false);
        navigate('/settings');
    };

    return (
        <div className="user-menu">
            <img
                className="profile-img s"
                src={authData?.avatarUrl || DEFAULT_AVATAR_URL}
                alt="avatar"
                data-testid="user-avatar"
                onClick={showMenuHandler}
                ref={ref}
            />
            {showMenu && (
                <ul className="dropdown-menu">
                    <li className="menu-element">
                        <Title text={authData?.name!} size="s" />
                    </li>
                    <li className="menu-element" onClick={navigateToMyProfile}>
                        <TextField size="s">
                            {t('userMenu.myProfile')}
                        </TextField>
                    </li>
                    <li className="menu-element" onClick={navigateToSettings}>
                        <TextField size="s">{t('userMenu.settings')}</TextField>
                    </li>
                    <li className="menu-element" onClick={logoutHandler}>
                        <TextField size="s">{t('userMenu.logout')}</TextField>
                    </li>
                </ul>
            )}
        </div>
    );
};

export default UserMenu;
